import {
  AttendeeFragment,
  InteractionForAttendeeFragment,
  InteractionFragment,
  PublicEWebinarFragment,
} from '$/GraphQL/schema/types';
import React, { FC } from 'react';
import * as yup from 'yup';

import { AttendeeCardProps, InteractionInfo, NoBodyCard } from '../InteractionInfo';
import {
  InteractionModalAccordionsHook,
  InteractionModalComponentProps,
  ModalValidationRules,
} from '../types';
import type { InteractionEditableValues, InteractionModalTitleProps } from '../types';
import { markdownToText } from '$/shared/frontend/utils/MarkdownConverter';
import TestimonialCard from './TestimonialCard';
import { yupIsValidUrl } from '$/utils/isUrl';
import { TestimonialIcon } from '$/images/FontAwesomeIcons';
import { StyleProps } from '$/components/ui';
import { AnalyticsCardProps } from '../cards/types';
import { useTestimonialSettings } from './useTestimonialSettings';

const AnalyticsClickCard = React.lazy(() => import('../cards/AnalyticsClickCard'));
const TestimonialModal = React.lazy(() => import('./TestimonialModal'));
export class TestimonialInfo extends InteractionInfo {
  public constructor(
    i: InteractionForAttendeeFragment | InteractionFragment,
    ewebinar?: PublicEWebinarFragment,
    attendee?: AttendeeFragment
  ) {
    super(i, ewebinar, attendee);
  }

  public typeName(): string | undefined {
    return `Testimonial`;
  }

  public icon(): FC<StyleProps> {
    return TestimonialIcon;
  }
  public modalTitleComponent(): FC<InteractionModalTitleProps> | null {
    return null;
  }
  public hasAnswers(): boolean {
    return Boolean(this.fragment.details?.link);
  }
  public hasPropertyNameField(): boolean {
    return false;
  }
  public hasEngagement(): boolean {
    return Boolean(this.fragment.details?.link);
  }

  public modalValidationRules(): ModalValidationRules {
    return {
      link: yupIsValidUrl(),
      testimonial: yup
        .object()
        .shape({
          quote: yup.string().required(),
          name: yup.string().required(),
          action: yup.string().nullable(),
        })
        .when('link', ([link]: string[], field: yup.AnyObjectSchema) => {
          if (!link || link.length === 0) return field;
          return field.test({
            name: 'hasLink',
            test: function (values) {
              const { action } = values;
              if (action && action.length > 0) return true;
              return this.createError({
                message: `This field is required.`,
                path: 'details.testimonial.action',
              });
            },
          });
        }),
    };
  }

  public async onSave(values: InteractionEditableValues): Promise<InteractionEditableValues> {
    const submitValues = { ...values };
    submitValues.details.title = markdownToText(submitValues.details.testimonial?.quote);

    return submitValues;
  }

  public useModalPreviewComponent(): React.LazyExoticComponent<
    React.FC<InteractionModalComponentProps>
  > | null {
    return TestimonialModal;
  }

  public modalSettingsAccordions(): InteractionModalAccordionsHook {
    return useTestimonialSettings;
  }

  public cardComponent(): FC<AttendeeCardProps> {
    return TestimonialCard;
  }

  public analyticsCardComponent(): React.LazyExoticComponent<React.FC<AnalyticsCardProps>> {
    return AnalyticsClickCard;
  }

  public cardBodyComponent(): FC {
    return NoBodyCard;
  }
}
